module.exports = __webpack_public_path__ + "jo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/jo.svg
// module id = 628
// module chunks = 0